import React from "react";
import logoUrl from "@/assets/qdrives-logo.png";

/**
 * QLogo — uses the official Q Drives shield image (bundled asset).
 *   variant="compact" (default): shield mark + "Q DRIVES" wordmark beside it (headers)
 *   variant="mark": only the shield badge
 *   variant="full": large standalone shield (login splash, success screens)
 */
export default function QLogo({ size = 40, variant = "compact", className = "" }) {
  const shieldStyle = {
    width: size,
    height: size,
    objectFit: "contain",
    flexShrink: 0,
  };

  if (variant === "mark") {
    return <img src={logoUrl} alt="Q Drives" style={shieldStyle} className={className} />;
  }

  if (variant === "full") {
    return (
      <img
        src={logoUrl}
        alt="Q Drives"
        style={{ width: size, height: size, objectFit: "contain" }}
        className={className}
      />
    );
  }

  // compact (default): shield + wordmark side-by-side
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img src={logoUrl} alt="Q Drives" style={shieldStyle} />
      <div className="font-display text-[14px] font-bold tracking-[0.18em] text-white leading-none">Q DRIVES</div>
    </div>
  );
}
